import React from 'react'
import Overlay from './overlay/Overlay'
import upload from "../../assets/svgs/upload.svg"
import { CssTextField } from '../../pages/user/UserProfile'
import { ChangeEvent, useState } from "react"

const UploadModal = ({
    isOpen,
    onClose,
  }: {
    isOpen: boolean;
    onClose: () => void;
  }) => {
    const [file, setFile] = useState<File>()
    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
      console.log(file)
      if(e.target.files) {
        setFile(e.target.files[0])
      }
      
    }
  return (
    <Overlay isOpen={isOpen} onClose={onClose} >
        <div className='flex flex-col mt-[2rem] items-center justify-center'>
            <p className='text-xl  font-semibold text-main-blue'>Upload your Documents</p>
            <p className='pt-[1rem] text-sm mb-[1rem]'>PDF and DOC files are allowed</p>

            <div className='w-[80%] flex flex-col items-center justify-center p-[2rem]  border-dashed border-[3px] border-main-blue bg-blue-100'>
                <img src={upload} alt="" />
                <p className='mt-[2rem]'>Drag and drop or browse to choose files</p>
                <div className='w-[50%] ml-[4rem] flex flex-col items-center justify-center'>
                <CssTextField 
                    required
                    fullWidth
                    id="cv"
                    type = "file"
                    label=""
                    size="small"
                    margin="normal"
                    onChange={handleFileChange}
                    helperText = "files should not be more than 5mb"
                /></div>
            </div>
        </div>
    </Overlay>
  )
}

export default UploadModal